import { GetGroupsADRequest, groupsADResponse } from "@/services/get-groups-ad/getGroupsADService";

export default function useGetGroupsAD() {
  const getGroupsAD = async (req: GetGroupsADRequest) => {
    const result = await fetch(`/api/get-grupos-ad?usuario=${req.usuario}`, {
      method: "GET"
    });
    const { data } = await result.json();
    const resultJson = data as groupsADResponse;
    return resultJson;
  };
  return getGroupsAD;
}
